export default __webpack_public_path__ + "locales/sr-Latn-RS/Payments.json?hash=6ada60b48b875a48e5e9bc8db4865f5c";